import React from 'react';
import { SHORT_DAY_ABBREVIATIONS } from '../../../../../../../utils/constants/dates';
import { DayButton, DaysContainer } from './EventsDaysSelector.styles';

const EventsDaysSelector = ({ normalizedSelectedDays, handleDayClick }) => {
  return (
    <DaysContainer>
      {SHORT_DAY_ABBREVIATIONS.map((day, index) => (
        <DayButton
          key={`${day}-${index}`}
          selected={normalizedSelectedDays.includes(index)}
          onClick={() => handleDayClick(index)}
        >
          {day}
        </DayButton>
      ))}
    </DaysContainer>
  );
};

export default EventsDaysSelector;
